import { useMutation } from "@tanstack/react-query";
import Api from "src/Config";
import { createContext, FunctionComponent, ReactElement, useMemo } from "react";

export const DeleteGroupContext = createContext(null);

type Props = {
  children: ReactElement;
};

const DeleteGroupProvider: FunctionComponent<Props> = ({ children }) => {
  const { mutateAsync, data, isPending, error } = useMutation({
    mutationFn: async (payload: any) => {
      const data = await Api.delete(
        `settings/tm/case-management/groups/${payload.group_id}`,
      );
      return data;
    },
    onError: (err) => {
      console.log(err, "###");
    },
  });

  const contextValue = useMemo(
    () => ({
      mutateAsync,
      data,
      isPending,
      error,
    }),
    [mutateAsync, data, isPending, error],
  );
  return (
    <DeleteGroupContext.Provider value={contextValue}>
      {children}
    </DeleteGroupContext.Provider>
  );
};

export default DeleteGroupProvider;
